"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const utils_1 = require("@loadsure/utils");
class PercentageFee {
    constructor(value, partnerId) {
        this.value = value;
        this.partnerId = partnerId;
        this.type = types_1.eFeeType.PERCENTAGE;
    }
    calculate(currency, value) {
        const feeAmount = utils_1.roundToDecimals(value * (this.value / 100));
        return feeAmount;
    }
    get isZero() {
        return this.value === 0;
    }
    get description() {
        return `${this.value}% of Premium`;
    }
}
exports.default = PercentageFee;
//# sourceMappingURL=percentageFee.class.js.map